import { render, staticRenderFns } from "./drawer-header.vue?vue&type=template&id=08122a1d&scoped=true"
import script from "./drawer-header.vue?vue&type=script&lang=js"
export * from "./drawer-header.vue?vue&type=script&lang=js"
import style0 from "./drawer-header.vue?vue&type=style&index=0&id=08122a1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08122a1d",
  null
  
)

export default component.exports